
export enum AuthStatus {
  authenticated = 'authenticated',
  inProgress = 'inProgress',
  notAuthenticated = 'notAuthenticated'
}
